import { ContentSortMode } from "@nova/constants"
import { SortableHeader } from "./SortableHeader"

export const StickyHeaderRow = () => {
    return (
        <div className="flex items-center border-y border-gray-700 text-gray-300 min-h-[1.875rem] pl-12">
            <SortableHeader title="Name" sortMode={ContentSortMode.Name} className="flex-[4]" />
            <SortableHeader
                title="Modified"
                sortMode={ContentSortMode.DateModified}
                className="flex-[1]"
            />
            <SortableHeader
                title="Created"
                sortMode={ContentSortMode.DateCreated}
                className="flex-[1]"
            />
        </div>
    )
}
